import { Toaster } from 'sonner';

/** Contenitore dei toast dell'app, con i colori dei token correnti. */
export function AppToaster() {
	return (
		<Toaster
			position="bottom-right"
			toastOptions={{
				style: {
					background: 'var(--color-card)',
					border: '1px solid var(--color-border)',
					color: 'var(--color-text-primary)',
				},
			}}
		/>
	);
}
